'use strict';

var MAXIMUM_SLATE_NOTE_LENGTH = 400;

var SlateController = /*@ngInject*/ function (NoteService) {
  var _self = this;

  _self.init = function () {
    _self.note = NoteService.getNotes(_self.job, 'SlateNote');
    var noteContent = (_self.note || [])
      .map(function (note) {
        return note.content;
      })
      .join('');
    _self.formattedSlateNote = noteContent.slice(0, MAXIMUM_SLATE_NOTE_LENGTH);

    if (_self.job && _self.job.product) {
      if (_self.job.product.styleColor) {
        _self.qrData = [_self.job.product.styleColor, _self.job.id].join('_');
      } else {
        _self.qrData = [_self.job.product.productId, _self.job.id].join('_');
      }
      if (_self.job.product.subcategory) {
        _self.combinedCategory = [
          _self.job.product.category,
          _self.job.product.subcategory
        ].join(' / ');
      } else {
        _self.combinedCategory = _self.job.product.category;
      }
      var age = _self.job.product.age || '';
      var gender = _self.job.product.gender || '';
      _self.segment = [age, gender].join(' / ');
      _self.job.expectedViews = _self.job.expectedViews || [];
      _self.job.expectedViews.sort();
    }
  };
};

module.exports = SlateController;
